var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { MeasurementUnit as MeasurementUnitProto } from '@square/dashboard-protos/models/squareup/connect/v2/common/measurement_units';
export let Area = /*#__PURE__*/function (Area) {
  Area["INVALID_AREA"] = "INVALID_AREA";
  Area["IMPERIAL_SQUARE_INCH"] = "IMPERIAL_SQUARE_INCH";
  Area["METRIC_SQUARE_CENTIMETER"] = "METRIC_SQUARE_CENTIMETER";
  Area["METRIC_SQUARE_METER"] = "METRIC_SQUARE_METER";
  Area["IMPERIAL_ACRE"] = "IMPERIAL_ACRE";
  Area["IMPERIAL_SQUARE_FOOT"] = "IMPERIAL_SQUARE_FOOT";
  Area["IMPERIAL_SQUARE_YARD"] = "IMPERIAL_SQUARE_YARD";
  Area["IMPERIAL_SQUARE_MILE"] = "IMPERIAL_SQUARE_MILE";
  Area["METRIC_SQUARE_KILOMETER"] = "METRIC_SQUARE_KILOMETER";
  return Area;
}({});
export let Length = /*#__PURE__*/function (Length) {
  Length["INVALID_LENGTH"] = "INVALID_LENGTH";
  Length["IMPERIAL_INCH"] = "IMPERIAL_INCH";
  Length["METRIC_MILLIMETER"] = "METRIC_MILLIMETER";
  Length["METRIC_METER"] = "METRIC_METER";
  Length["IMPERIAL_FOOT"] = "IMPERIAL_FOOT";
  Length["IMPERIAL_YARD"] = "IMPERIAL_YARD";
  Length["IMPERIAL_MILE"] = "IMPERIAL_MILE";
  Length["METRIC_CENTIMETER"] = "METRIC_CENTIMETER";
  Length["METRIC_KILOMETER"] = "METRIC_KILOMETER";
  return Length;
}({});
export let Volume = /*#__PURE__*/function (Volume) {
  Volume["INVALID_VOLUME"] = "INVALID_VOLUME";
  Volume["GENERIC_FLUID_OUNCE"] = "GENERIC_FLUID_OUNCE";
  Volume["METRIC_MILLILITER"] = "METRIC_MILLILITER";
  Volume["METRIC_LITER"] = "METRIC_LITER";
  Volume["GENERIC_SHOT"] = "GENERIC_SHOT";
  Volume["GENERIC_CUP"] = "GENERIC_CUP";
  Volume["GENERIC_PINT"] = "GENERIC_PINT";
  Volume["GENERIC_QUART"] = "GENERIC_QUART";
  Volume["GENERIC_GALLON"] = "GENERIC_GALLON";
  Volume["IMPERIAL_CUBIC_INCH"] = "IMPERIAL_CUBIC_INCH";
  Volume["IMPERIAL_CUBIC_FOOT"] = "IMPERIAL_CUBIC_FOOT";
  Volume["IMPERIAL_CUBIC_YARD"] = "IMPERIAL_CUBIC_YARD";
  return Volume;
}({});
export let Weight = /*#__PURE__*/function (Weight) {
  Weight["INVALID_WEIGHT"] = "INVALID_WEIGHT";
  Weight["IMPERIAL_WEIGHT_OUNCE"] = "IMPERIAL_WEIGHT_OUNCE";
  Weight["METRIC_MILLIGRAM"] = "METRIC_MILLIGRAM";
  Weight["METRIC_GRAM"] = "METRIC_GRAM";
  Weight["METRIC_KILOGRAM"] = "METRIC_KILOGRAM";
  Weight["IMPERIAL_POUND"] = "IMPERIAL_POUND";
  Weight["IMPERIAL_STONE"] = "IMPERIAL_STONE";
  return Weight;
}({});
export let Time = /*#__PURE__*/function (Time) {
  Time["INVALID_TIME"] = "INVALID_TIME";
  Time["GENERIC_MILLISECOND"] = "GENERIC_MILLISECOND";
  Time["GENERIC_SECOND"] = "GENERIC_SECOND";
  Time["GENERIC_MINUTE"] = "GENERIC_MINUTE";
  Time["GENERIC_HOUR"] = "GENERIC_HOUR";
  Time["GENERIC_DAY"] = "GENERIC_DAY";
  return Time;
}({});
export let Generic = /*#__PURE__*/function (Generic) {
  Generic["INVALID_GENERIC_UNIT"] = "INVALID_GENERIC_UNIT";
  Generic["UNIT"] = "UNIT";
  return Generic;
}({});
let Unit = (_dec = fragment('connect/measurement-unit/unit/custom'), _dec2 = attr('string', {
  protoEnum: MeasurementUnitProto.Area
}), _dec3 = attr('string', {
  protoEnum: MeasurementUnitProto.Length
}), _dec4 = attr('string', {
  protoEnum: MeasurementUnitProto.Volume
}), _dec5 = attr('string', {
  protoEnum: MeasurementUnitProto.Weight
}), _dec6 = attr('string', {
  protoEnum: MeasurementUnitProto.Time
}), _dec7 = attr('string', {
  protoEnum: MeasurementUnitProto.Generic
}), _class = (_class2 = class Unit extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "customUnit", _descriptor, this);
    _initializerDefineProperty(this, "areaUnit", _descriptor2, this);
    _initializerDefineProperty(this, "lengthUnit", _descriptor3, this);
    _initializerDefineProperty(this, "volumeUnit", _descriptor4, this);
    _initializerDefineProperty(this, "weightUnit", _descriptor5, this);
    _initializerDefineProperty(this, "timeUnit", _descriptor6, this);
    _initializerDefineProperty(this, "genericUnit", _descriptor7, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/measurement-unit/unit'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "customUnit", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "areaUnit", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "lengthUnit", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "volumeUnit", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "weightUnit", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "timeUnit", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "genericUnit", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Unit as default };